import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { communicationsMethods } from 'const';

export default ({ isHomeNumberFilled, isMobileNumberFilled, isHomeNumberVisible, isMobileNumberVisible }) => {
  const { t, i18n } = useTranslation('labels');
  const preferredCommunicationOptions = useMemo(() => {
    const options = [];
    options.push({ value: communicationsMethods.email, label: t('email') });
    if (isMobileNumberVisible) {
      options.push({ value: communicationsMethods.textSms, label: t('text_sms'), disabled: !isMobileNumberFilled });
    }
    if (isHomeNumberVisible) {
      options.push({ value: communicationsMethods.voice, label: t('voice'), disabled: !isHomeNumberFilled });
    }
    return options;
  }, [i18n.language, isHomeNumberFilled, isMobileNumberFilled, isHomeNumberVisible, isMobileNumberVisible]);

  return { data: preferredCommunicationOptions };
};
